import { isHexColor } from './colorUtils.shared';

export {
  darkenHex,
  isCloseToWhite,
  isHexColor,
  lightenHex,
  normalizeHexColor,
} from './colorUtils.shared';

import type { ColorValue } from 'react-native';

function isCssVariable(color: string): boolean {
  return color.trim().startsWith('var(');
}

export function addOpacityToHex(hex: string, opacity: number): ColorValue {
  if (opacity < 0 || opacity > 1) {
    throw new Error(`Invalid opacity: ${opacity}. Must be between 0 and 1.`);
  }

  if (isCssVariable(hex)) {
    return `color-mix(in srgb, ${hex} ${opacity * 100}%, transparent)`;
  }

  if (!isHexColor(hex)) {
    throw new Error(
      `Invalid hex color: ${hex}. Must be a valid hex color or CSS variable.`,
    );
  }

  const cleanHex = hex.replace('#', '');

  let r: string;
  let g: string;
  let b: string;

  if (cleanHex.length === 3) {
    r = cleanHex[0] + cleanHex[0];
    g = cleanHex[1] + cleanHex[1];
    b = cleanHex[2] + cleanHex[2];
  } else {
    r = cleanHex.substring(0, 2);
    g = cleanHex.substring(2, 4);
    b = cleanHex.substring(4, 6);
  }

  const red = parseInt(r, 16);
  const green = parseInt(g, 16);
  const blue = parseInt(b, 16);

  return `rgba(${red}, ${green}, ${blue}, ${opacity})`;
}
